import React from 'react'
import { Link } from 'react-router-dom'
import img from '../../../assets/farm/ripped-paper-header-1-farms-page.png'

const Bannar = (props) => {
    return (
        <>
            <div className='ripped-paper-base' style={{
                backgroundImage: `url(${img})`, height: "16px", backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                position: "relative", top: 12, left: 0,
                // transform: "rotate(180deg)"
                
            }}></div>
            <div className='banner-bg d-flex justify-content-center align-items-center' style={{
                backgroundImage: `url(${props.img})`,
                height: "45vh",
                backgroundPosition: "center center",
                backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundAttachment:`${props.attachment}`
            }}  >
                <div>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb" style={{lineHeight:2, wordSpacing:2, letterSpacing:1}}>
                            <li className="breadcrumb-item banner-font "><Link className='text-white text-decoration-none h1' to="/">Home</Link></li>
                            <li className="breadcrumb-item banner-font active text-white h1 text-decoration-underline" aria-current="page">{props.name}</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div className='ripped-paper-base' style={{
                backgroundImage: `url(${img})`, height: "16px", backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
                position: "relative", bottom: 12, left: 0,
                transform: "rotate(180deg)"
                
            }}></div>
        </>
    )
}

export default Bannar